import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ChevronRightSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ChevronRightSVG;
